import { InputGroup } from '@blueprintjs/core';
import { DateInput } from '@blueprintjs/datetime';
import Clearfix from 'components/elements/clearfix';
import YearSelect from 'components/elements/select-year';
import { DATE_FORMAT } from 'config';
import { getDataForCustomSelect } from 'constants/custom-data';
import moment from 'moment';
import NumberInput from 'rc-input-number';
import React from 'react';
import { Col, Row } from 'reactstrap';
import { convertDateFromSever } from 'utils/fnUtil';
import { FIELDS } from '../constants';
import { LabelContainer } from './index';

const HazardWasteReportForm = (props) => {
  const {
    setInitialValue,
    form: { getFieldProps },
  } = props;
  return (
    <React.Fragment>
      <Row>
        <Col xs={4}>
          <LabelContainer>Năm báo cáo</LabelContainer>
        </Col>
        <Col xs={4}>
          <YearSelect
            hideLabel
            fieldForm={{
              form: props.form,
              name: 'NamThucHienBaoCao',
              option: {
                initialValue: getDataForCustomSelect(
                  setInitialValue('NamThucHienBaoCao', '')
                ),
              },
            }}
          />
        </Col>
      </Row>

      <Clearfix height={8} />
      <Row>
        <Col xs={4}>
          <LabelContainer>Hình thức nộp báo cáo</LabelContainer>
        </Col>
        <Col xs={4}>
          <InputGroup
            placeholder='Hình thức nộp báo cáo'
            {...getFieldProps('HinhThucNop', {
              initialValue: setInitialValue('HinhThucNop', null),
            })}
          />
        </Col>
      </Row>

      <Clearfix height={8} />

      <Row>
        <Col xs={4}>
          <LabelContainer>Ngày nộp báo cáo</LabelContainer>
        </Col>
        <Col xs={4}>
          <DateInput
            formatDate={(date) => moment(date).format(DATE_FORMAT)}
            parseDate={(str) => moment(str).toDate()}
            placeholder='Ngày nộp báo cáo'
            {...getFieldProps('NgayNopBaoCao', {
              initialValue: convertDateFromSever(
                setInitialValue('NgayNopBaoCao', null)
              ),
            })}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={4}>
          <LabelContainer>Khối lượng phát sinh (kg)</LabelContainer>
        </Col>
        <Col xs={4}>
          <NumberInput
            placeholder='Khối lượng phát sinh (kg)'
            {...getFieldProps(FIELDS.KhoiLuongPhatSinh, {
              initialValue: setInitialValue(FIELDS.KhoiLuongPhatSinh, null),
            })}
          />
        </Col>
      </Row>

      <Clearfix height={8} />

      <Row>
        <Col xs={4}>
          <LabelContainer>Khối lượng chuyển giao (kg)</LabelContainer>
        </Col>
        <Col xs={4}>
          <NumberInput
            placeholder='Khối lượng chuyển giao (kg)'
            {...getFieldProps(FIELDS.KhoiLuongChuyenGiao, {
              initialValue: setInitialValue(FIELDS.KhoiLuongChuyenGiao, null),
            })}
          />
        </Col>
      </Row>

      <Clearfix height={8} />

      <Row>
        <Col xs={4}>
          <LabelContainer>Khối lượng tự xử lý (kg)</LabelContainer>
        </Col>
        <Col xs={4}>
          <NumberInput
            placeholder='Khối lượng tự xử lý (kg)'
            {...getFieldProps(FIELDS.KhoiLuongTuXuLy, {
              initialValue: setInitialValue(FIELDS.KhoiLuongTuXuLy, null),
            })}
          />
        </Col>
      </Row>

      <Clearfix height={8} />
      <Row>
        <Col xs={4}>
          <LabelContainer>Khối lượng tồn lưu (kg)</LabelContainer>
        </Col>
        <Col xs={4}>
          <NumberInput
            placeholder='Khối lượng tồn lưu (kg)'
            {...getFieldProps(FIELDS.KhoiLuongTonLuu, {
              initialValue: setInitialValue(FIELDS.KhoiLuongTonLuu, null),
            })}
          />
        </Col>
      </Row>

      <Clearfix height={8} />
      <Row>
        <Col xs={4}>
          <LabelContainer>Phương pháp xử lý</LabelContainer>
        </Col>
        <Col xs={4}>
          <InputGroup
            placeholder='Phương pháp xử lý'
            {...getFieldProps(FIELDS.PhuongPhapXuLy, {
              initialValue: setInitialValue(FIELDS.PhuongPhapXuLy, null),
            })}
          />
        </Col>
      </Row>

      <Clearfix height={8} />
      <Row>
        <Col xs={4}>
          <LabelContainer>Đơn vị thu gom</LabelContainer>
        </Col>
        <Col xs={4}>
          <InputGroup
            placeholder='Đơn vị thu gom'
            {...getFieldProps(FIELDS.DonViThuGom, {
              initialValue: setInitialValue(FIELDS.DonViThuGom, null),
            })}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default HazardWasteReportForm;



// WEBPACK FOOTER //
// ./src/containers/FacilityHazarWasteReportContainer/FacilityHazarWasteReportForm/HazarWasteReportForm.js